var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_427_5012",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_427_5012)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18.5908,
    y: -19.9797,
    width: 114.828,
    height: 107.172,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_427_5012",
    transform: "scale(0.0238095)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_427_5012",
    width: 42,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAFaUlEQVRYhcWZbYhUZRTH//9z587sOrqCq9PuloJl4IfCDy5aidlGL6ZClBRClKnrbrvS5BdBBemWQoYiMa7kdXEjKdAVenEpMEkmTIXSJLEwEFpicXBcFll03RnnPqcPsyv7dmdndGf8fZoP57nPb+6dc85z7hBDcBwnEIlEZtm2/ZqqrgDwBMkKABcDgcCLa9asuYEHhDX44dChQ+Hy8vK3LMs6BGAlydkkJw3EVHueF54/f/6JeDxuHoSoAIDjOMH+/v7lALYCqAHAEXEEsDoSiTxdYr+7CABEIpHZJJtIzsZoSQAAySmBQCAai8UqSmo4gLiua9u2vQrAIgyI+0CSS0Kh0MslchuGBIPBSgDrANh5xFeKyBuu61YX2WsUkk6nXwXwSL7xAJ4D8JLruvl8sQlDSL4On9+lD9NF5F3P8x4tltRYCIB5Ba4hgGcCgUBDEXx8EZJT72FdkOTqffv2VU24kQ+C3Jnui6pKIBDITLCPLwLgZoFrVFWTJDc3NjZ2F0NqLERVLxcQ7wH4C8AWY8xXRXIaE1HVnwBoHrGqquc8z9ukqocbGxv7ii03FAHQoar9ecSe9zyvftq0aSdKLQkAAQCXSZ4DsDhHXBLAiqampmul0RqNJBKJtDHmW1X1zWBVvW6M6Sml2EjEcZwMgDMAunLEzVHVpSVyGhMBABHpBHAaPklFMmRZ1kd79+6tKaXcUCwAKCsr658zZ06Fqj5Lstwn9iERMbW1tSfj8Xg+VWJCEQA4evSol0qlTgO4CP9SJSRXVVVVLSyZ3dDNBz90d3dfAfADgNt+wSRrROS9Uvb4Qe4Od/F4XJctW3ZVROqQnZvGQkg+LCI9dXV1F48fP17SXn+XpqamTlXdBSBXQa8k2TxlypS64qoNZ9TJ6erVq8eMMQdU1W8sJrLlaqfruk8WV2/4pqNoaWmptG37GxFZ7BcDQI0x/3qet6y5ufmf4ilm8ZOg67qLROQggMdzxMEYcwFAUyKROD/QPPLCdd1JAB4zxqgxpnPDhg23kONw5Hdo1lQq9TuA7aramesCJOeR3F9dXf3mwObjcvDgwRoAH5P81bKsn23b3t3a2rqwvb3d8luTc6iLxWIVoVBonYhsBTA9R6gB0GmMabMs6/P6+nrfc0EsFpsRCoW2ikgjgMHmklbVP1X1iIgcWb9+/ah2Pu706bruVBGJAvgQQ8rZGCiAXpJn0un0J8lk8rTjOMMScs+ePeXhcLhZRDYDqByxvwLoBXDB87wv0un0d9FotDdvUQBob28P9vT0bLMsa8s4skD27iaNMW23b9+Obdy48RoAqCoPHDjwqoh8BmBWjr2NqvYB+CWTyexIJpO/OY5jCpnn6bruDpJRkuEcGw3iIXvY/pTk2UwmM9e27f0kcybnEFRVe0l+efPmzZ2BAkS1r69vVzgcpqquIzljnA0tAAssy/oawJVQKFStqtPylASy77qmAng/HA7XFHJHAQBtbW0z7ty5s4bkByRLcuwzxlwoeKZfu3bt9VQqtV9VN6nqf8hvMLwvSPbe08uHaDTam0gkDnuetwTASWQTqGh4nvd3wY9+JC0tLZXBYHATyXcARDB+VSgIVTWquvK+RYFsfZw8efJSko2q+tTAHxQTcW1V1Quq+vyEiA7S2to62xiznOQrJBcCKCTLR+IB+ENVtzU0NByf0MfU0dFxo7a29lx5eflZAOcB3EC2A1WQzFdYVfUWye+NMdsTicSpeDxeUMEvCMdxZObMmeFMJhMBUAfgbRFZACCEHEdHVb1Ecrcx5sdEItEz2IaLJjoSx3GkqqpqLskXSC4iOdMYUyYi3kAHukTyWFdX1ynHcdIj1/8PchQQ4oItksMAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5cd412dda0724c42f9e8930b84376ba0.svg";
export { ForwardRef as ReactComponent };